import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Properties for {@link SubnetRedirect}
 */
type SubnetRedirectProps = {};

/**
 * Redirect page for subnets
 */
function SubnetRedirect(props: SubnetRedirectProps) {
    return <Navigate to={"/c/subnets/approved"} search={{ page: 1 }} />;
}

export const Route = createFileRoute("/_customer/c/subnets/")({
    component: SubnetRedirect,
});
